import React from 'react';
import { SEMANTIC_HR_CONTACT_HREF } from '../../../../content/enterpriseMessaging';

const catalogStats = [
  { value: '130+', label: 'Reference metrics shipped' },
  { value: '400+', label: 'Expandable catalog scope' },
  { value: '6', label: 'HR domains covered' },
];

const catalogDomains = [
  {
    title: 'Workforce & Headcount',
    count: '40+',
    status: 'Reference',
    desc: 'Headcount, FTE, manager counts, and org breakdowns by location, department, and job family.',
  },
  {
    title: 'Hires & Attrition',
    count: '80+',
    status: 'Reference',
    desc: 'Hire and termination rates with YTD, TTM, and trailing windows, voluntary, involuntary, and regrettable loss.',
  },
  {
    title: 'Recruiting & Pipeline',
    count: '60+',
    status: 'Reference',
    desc: 'Requisitions, time-to-fill, stage aging, pass-through rates, and offer conversion.',
  },
  {
    title: 'Compensation & Labor Cost',
    count: '50+',
    status: 'Role-governed',
    desc: 'Salary, compa-ratio, pay equity inputs, labor cost, and plan variance, with domain access controls.',
  },
  {
    title: 'DEI & Performance',
    count: '35+',
    status: 'Role-governed',
    desc: 'Representation metrics, performance ratings, succession coverage, and high-performer attrition.',
  },
  {
    title: 'Planning & Scenarios',
    count: '45+',
    status: 'Expandable',
    desc: 'Plan vs actual headcount, sensitivity analysis, RIF and restructuring scenarios, position fill rates, and forecast assumptions.',
  },
];

export default function MetricsCatalogHighlight() {
  return (
    <section id="metrics" className="py-10 md:py-12 scroll-mt-24">
      <div className="container-x">
        <div className="max-w-3xl mb-6">
          <p className="eyebrow">HR Metrics Catalog</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-ink-900">
            One Catalog. Every Surface.
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink-600">
            Same definitions in Power BI dashboards, Snowflake reporting views, and copilot answers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8 max-w-3xl">
          {catalogStats.map((s) => (
            <div key={s.label} className="rounded-xl border border-brand-100 bg-brand-50/50 px-5 py-4">
              <p className="text-2xl font-semibold text-brand-700">{s.value}</p>
              <p className="mt-1 text-sm text-ink-600">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 content-start">
            {catalogDomains.map((domain) => (
              <div
                key={domain.title}
                className="border-l-2 border-l-brand-200 pl-4 py-2"
              >
                <div className="flex items-start justify-between gap-2">
                  <p className="text-sm font-semibold text-ink-900">{domain.title}</p>
                  <span
                    className={`shrink-0 text-xs font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full ${
                      domain.status === 'Reference'
                        ? 'bg-emerald-50 text-emerald-700' /* Product mock: catalog certification state */
                        : domain.status === 'Role-governed'
                          ? 'bg-amber-50 text-amber-800'
                          : 'bg-ink-100 text-ink-600'
                    }`}
                  >
                    {domain.status}
                  </span>
                </div>
                <p className="text-xs text-brand-600 font-medium mt-1">{domain.count} metrics</p>
                <p className="text-sm text-ink-500 leading-relaxed mt-1">{domain.desc}</p>
              </div>
            ))}
          </div>

          <div className="lg:sticky lg:top-24 self-start rounded-2xl border border-ink-200 bg-white p-6 sm:p-8 shadow-xs">
            <p className="text-base font-semibold text-ink-900">Governed KPIs on your terms</p>
            <p className="mt-3 text-sm text-ink-600 leading-relaxed">
              Reference metrics ship in the Workday and SuccessFactors demo environment. Extended
              catalog metrics expand as your analytics program matures.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row flex-wrap gap-3">
              <a href={SEMANTIC_HR_CONTACT_HREF} className="btn-primary">
                Request catalog walkthrough
              </a>
              <a href="#use-cases" className="btn-ghost text-sm">
                See use cases →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
